var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsubscribed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38825 3.69891L3.69849 5.38867L20.6029 22.293L22.2926 20.6033L5.38825 3.69891Z",
    fill: "#EA5454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C5.83088 26 0 20.1691 0 13C0 5.83088 5.83088 0 13 0C20.1691 0 26 5.83088 26 13C26 20.1691 20.1691 26 13 26ZM13 2.09338C6.9875 2.09338 2.10294 6.9875 2.10294 12.9904C2.10294 18.9934 6.99706 23.8875 13 23.8875C19.0029 23.8875 23.8971 18.9934 23.8971 12.9904C23.8971 6.9875 19.0125 2.09338 13 2.09338Z",
    fill: "#EA5454"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribed);
export default __webpack_public_path__ + "static/media/unsubscribed.866011df3ae2d1178fd648ca1313286b.svg";
export { ForwardRef as ReactComponent };